import { ErrorHandler, Injectable } from '@angular/core';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from './logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @angular-eslint/prefer-inject -- always constructed manually via `new GlobalErrorHandler(App.X)`, never resolved through Angular DI, so inject() is not applicable here
  constructor(private readonly appName: App) {}

  handleError(error: Error): void {
    if (error == null) {
      PS20Logger.error(this.appName, 'No Stacktrace because error is null');
    }

    PS20Logger.error(this.appName, error);
  }
}
